import React from 'react';
import 'rc-dialog/assets/bootstrap.css';
import SelectCommonDefault from './Common/SelectCommonDefault';


class TarjetaTitular extends React.Component {

    constructor( props ) {
        super( props );
        this.state = {
        };
    }

    handleChangeDenominacionCuartaLinea(e) {
        this.props.onBlurTextBox("denominacionCuartaLinea", e.target.value);  
    }

    handleChangeDenominacion1(e) {

        let denominacion = this.props.data.denominacion1
        
        let regExp = new RegExp(/^[a-záéíóúñÑA-Z\.]*$/);

        if(regExp.test(e.target.value) || (denominacion && denominacion.length > e.target.value.length)){
            this.props.onBlurTextBox("denominacion1", e.target.value);
        }
    }

    handleChangeDenominacion2(e) {

        let denominacion = this.props.data.denominacion2

        let regExp = new RegExp(/^[a-záéíóúñÑA-Z\.]*$/);
        
        if(regExp.test(e.target.value) || (denominacion && denominacion.length > e.target.value.length)){
            this.props.onBlurTextBox("denominacion2", e.target.value);        
        }
    }
    
    componentDidUpdate() {

        const { tarjetas, data, onBlurTextBox, selectCombo } = this.props;

        let parametrosGenerales = data.GET_ATLAS_PARAMETRO_GENERAL;
        let productoVisa = {}

        if(tarjetas.administradora.Id == 1){
            productoVisa = data.GET_PRODUCTO_VISA_PRODUCTO_ID
        }else if(tarjetas.administradora.Id == 2){
            productoVisa = data.GET_PRODUCTO_CABAL_PRODUCTO_ID  
        }
        
        let habilitacionCajero = data.GET_HABILITACION_CAJERO_PRODUCTO.map(habilitacion => { return { Id: habilitacion.ID, Descripcion: habilitacion.CODIGO + " - " + habilitacion.CODIGO } })
        let distribucionLimites = productoVisa ? data.ATLAS_DISTRIBUCION : [];
        let textoCuartaLinea = ' ';
        
        //  POR DEFAULT SE DEBE UTILIZAR EL NOMBRE Y APELLIDO DEL CLIENTE, CON UN MÁXIMO DE 17 CARACTERES PARA EL APELLIDO Y LOS QUE RESTEN ENTRE ESE NÚMERO Y 18 PARA EL NOMBRE
        let caracteresApellido = 0;
        let apellido = tarjetas.clienteResultadoBusqueda.APELLIDO.substring(0,16);
        caracteresApellido = apellido.length;
        let nombre = tarjetas.clienteResultadoBusqueda.NOMBRE.substring(0,(17-caracteresApellido));
        
        if(!this.props.tarjetas.vuelveDeAdicional && tarjetas.solicitudCuenta && productoVisa && productoVisa.Id && tarjetas.esModificacion && !data.tarjetaTitularModificacion){
            //DE SER UNA MODIFICACIÓN SE DEBE BUSCAR EL TITULAR ENTRE LAS TARJETAS DE LA SOLICITUD
            let titular = tarjetas.datosSolicitud.tarjetasSolicitud.filter(tarjeta=>tarjeta.EsAdicional == "0");
            titular = titular[0] && titular[0];

            if(titular.CuartaLinea){
                this.props.onBlurTextBox("denominacionCuartaLinea", titular.CuartaLinea);
            }
            if(titular.Nombre){
                this.props.onBlurTextBox("denominacion1", titular.Nombre);
                this.props.onBlurTextBox("denominacion2", titular.Apellido);
            }
            //SI LOS DATOS SE CARGARON CORRECTAMENTE, SE PASA A TRUE EL FLAG QUE LO INDICA 
            this.props.cargarAdicionalesModificacion();
            if(data.denominacion1 == titular.Nombre && data.denominacion2 == titular.Apellido) this.props.cargarDatosModificacion("tarjetaTitularModificacion");

        }
        if(productoVisa && this.props.data.denominacion2 == undefined && !this.props.tarjetas.esModificacion) this.props.onBlurTextBox("denominacion2", apellido);
        if(productoVisa && this.props.data.denominacion1 == undefined && !this.props.tarjetas.esModificacion) this.props.onBlurTextBox("denominacion1", nombre);
        

        if (tarjetas.administradora.Id == 1 && parametrosGenerales.SINODENOMINACIONCUARTALINEA && productoVisa && productoVisa.TipoGrabadoCuartaLinea && data.denominacionCuartaLinea == null) {
            
            if (productoVisa.TipoGrabadoCuartaLinea == "Cartera" && data && data.carteraId){
                textoCuartaLinea = (data.GET_CARTERAS_PRODUCTO && data.GET_CARTERAS_PRODUCTO.length>0 && data.carteraId>0) ? data.GET_CARTERAS_PRODUCTO.filter(cartera => cartera.Id == data.carteraId)[0].Descripcion: ' ';
            }
            else if (productoVisa.TipoGrabadoCuartaLinea == "GAF" && data && data.grupoAfinidadSeleccionadoId){
                textoCuartaLinea = (data.ATLAS_GRUPO_AFINIDAD && data.ATLAS_GRUPO_AFINIDAD.length > 0 && data.grupoAfinidadSeleccionadoId >0 ) ? data.ATLAS_GRUPO_AFINIDAD.filter(cartera => cartera.Id == data.grupoAfinidadSeleccionadoId)[0].Descripcion: ' ';
            }
            else if (productoVisa.TipoGrabadoCuartaLinea == "Sucursal" && data && data.sucursalSeleccionadaId){
                textoCuartaLinea = (data.ATLAS_SUCURSALES && data.ATLAS_SUCURSALES.length>0 && data.sucursalSeleccionadaId > 0) ? data.ATLAS_SUCURSALES.filter(cartera => cartera.Id == data.sucursalSeleccionadaId)[0].Descripcion : ' ';
            }
            else if (productoVisa.TipoGrabadoCuartaLinea == "ModLiq" && data && data.modeloLiquidacionId){
                textoCuartaLinea = (data.GET_MODELO_LIQUIDACION_PRODUCTO && data.GET_MODELO_LIQUIDACION_PRODUCTO.length >0 &&  parseInt(data.modeloLiquidacionId) >0) ? data.GET_MODELO_LIQUIDACION_PRODUCTO.filter(cartera => cartera.ID == data.modeloLiquidacionId)[0].DESCRIPCION:' ';
            }
            else if (productoVisa.TipoGrabadoCuartaLinea == "Texto")
                textoCuartaLinea = productoVisa.TextoCuartaLinea;

            if (textoCuartaLinea != ' ') {
                onBlurTextBox("denominacionCuartaLinea", textoCuartaLinea);
            }
        } else if (!productoVisa && (data.denominacionCuartaLinea || data.denominacion1 || data.denominacion2 )) {
            onBlurTextBox("denominacionCuartaLinea", undefined);
            onBlurTextBox("denominacion1", undefined);
            onBlurTextBox("denominacion2", undefined);
        }
    }

    render() {
        
        const { tarjetas, data, onBlurTextBox, selectCombo } = this.props;
        let parametrosGenerales = data.GET_ATLAS_PARAMETRO_GENERAL;
        let productoVisa = {}
        
        if(tarjetas.administradora.Id == 1){
            productoVisa = data.GET_PRODUCTO_VISA_PRODUCTO_ID;
        }else if(tarjetas.administradora.Id == 2){
            productoVisa = data.GET_PRODUCTO_CABAL_PRODUCTO_ID;
        }
        let valoresDefault = {};
        let categoriaCajeroModif = "";
        let codigoDistribucionModif = "";

        let titularModificacion = {};

        tarjetas.esModificacion && tarjetas.datosSolicitud.tarjetasMapeadas.map(tarjeta=>{
            if(tarjeta.EsTitular) titularModificacion = tarjeta
        });

        codigoDistribucionModif = titularModificacion.CodigoDistribucionId ? titularModificacion.CodigoDistribucionId : "";
        

        if(tarjetas.esModificacion == false){
            if(tarjetas.administradora.Id==1){
                valoresDefault = data.GET_PRODUCTO_DEFAULT_VISA_PRODUCTO
            }else if(tarjetas.administradora.Id==2){
                valoresDefault = data.GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO
            } 
        }else{
            if(tarjetas.administradora.Id==1){
                valoresDefault = tarjetas.datosSolicitud;
                categoriaCajeroModif = tarjetas.datosSolicitud.CategoriaCajeroVisaId;
                //SI SE TRATA DE UNA MODIFICACION, PUEDE QUE EL CODIGO DE DISTRIBUCIÓN NO VENGA POR DEFAULT EN EL PRODUCTO, POR LO QUE PARA DATOS GENERALES
                //SE SELECCIONA EL CODIGO DE DISTRIBUCIÓN QUE HAYA ELEGIDO EL TITULAR
                if(!data.codigoDistribucionSeleccionadoId && codigoDistribucionModif != "" ){
                    this.props.selectCombo("codigoDistribucionSeleccionadoId",codigoDistribucionModif)
                }
            }else if(tarjetas.administradora.Id==2){
                valoresDefault = tarjetas.datosSolicitud;
                categoriaCajeroModif = null //ver
            } 
        }
        let habilitacionCajero = data.GET_HABILITACION_CAJERO_PRODUCTO.map(habilitacion => { return { Id: habilitacion.ID, Descripcion: habilitacion.CODIGO + " - " + habilitacion.DESCRIPCION}})
        let distribucionLimites = productoVisa ? data.ATLAS_DISTRIBUCION : [];
        
        return (
            <div className="row">

                {tarjetas && tarjetas.clienteResultadoBusqueda && tarjetas.clienteResultadoBusqueda.esPersonaFisica && tarjetas.administradora.Id ==1 ? 

                    (<div className="col-md-12">
                        <div className="row">
                            <div className="correspondencia-contacto-cliente col-md-12">
                                <div className="divisor-section bottom-separator bottom-separator-xs" >
                                    <h2>Tarjeta Titular</h2>
                                </div>
                            </div>
                            <div className="col-md-12 bottom-separator-xs">
                                <div className="form-group  datos-generales-cuenta">
                                    <label className="label-primary">Denominación</label><br></br>
                                    <input maxLength="17" type="text" placeholder="Nombre" className="input-separate-right inputAlta" id="denominacion1Text" value={data.denominacion1} onChange={this.handleChangeDenominacion1.bind(this)}/>
                                    <input maxLength="17" type="text" placeholder="Apellido" className="input-separate-right inputAlta" id="denominacion2Text" value={data.denominacion2} onChange={this.handleChangeDenominacion2.bind(this)}/>
                                </div>
                                    {(!data.ERROR_CUENTA["denominacionTarjetaTitular"]&& (data.denominacion1 && data.denominacion2 && ((data.denominacion1.length + data.denominacion2.length)>18)))
                                    && <label className="error">{"El Nombre y Apellido para la denominacion no pueden superar los 18 caracteres. "}</label>
                                    }
                                    {(!data.ERROR_CUENTA["denominacionTarjetaTitular"]&& ((data.denominacion1!="" && data.denominacion2!="") && ((data.denominacion1 && data.denominacion1[0] == ".") || (data.denominacion2 && data.denominacion2[0] == "."))))
                                        && <label className="error">{"El primer caracter no puede ser un punto. "}</label>
                                    }
                                    {(!data.ERROR_CUENTA["denominacionTarjetaTitular"]&& (!data.denominacion1||!data.denominacion2))
                                        && <label className="error">{"Debe ingresar un Nombre y Apellido"}</label>}
                            </div>

                            {data.GET_ATLAS_PARAMETRO_GENERAL.SINODENOMINACIONCUARTALINEA && productoVisa &&  productoVisa.TipoGrabadoCuartaLinea != null ? 
                                (<div className="col-md-12">
                                    <div className="form-group bottom-separator-xs">
                                        <label className="label-primary">Denominación 4ta Línea</label>
                                        <div >
                                            <label className="funcionamiento-limites-input">Grabado 4ta Línea</label>
                                            <input maxLength="19"  className="input-separate inputAlta" type="text" id="denominacionCuartaLineaText" value={data.denominacionCuartaLinea} onChange={this.handleChangeDenominacionCuartaLinea.bind(this)}/>
                                        </div>
                                        {!data.ERROR_CUENTA["denominacionCuartaLinea"] && <label className="error">{"La Denominación de Cuarta Línea no puede superar los 19 caracteres. "}</label>}
                                    </div>
                                </div>) : null}

                            {productoVisa && productoVisa.UtilizaCodigoDistribucion && <div className="col-md-12">
                                <div className="form-group bottom-separator-xs datos-generales-cuenta">
                                    <label className="label-primary">Distribución</label>
                                    <SelectCommonDefault infoData={distribucionLimites} valorCombo={!tarjetas.esModificacion ? data.codigoDistribucionSeleccionadoId:codigoDistribucionModif} selectCombo={selectCombo} nombreAction={"distribucionTitularId"} selecciones={data}/>
                                </div>
                            </div>}
                             {parametrosGenerales.SINOREDBANELCO && tarjetas.administradora.Id == 1 ? 
                                (<div className="col-md-12">
                                    <div className="form-group bottom-separator-xs datos-generales-cuenta">
                                        <label className="label-primary">Habilitación Cajeros</label>
                                        <SelectCommonDefault infoData={habilitacionCajero} valorCombo={!tarjetas.esModificacion ? valoresDefault.HabilitacionCajerosDefaultId : categoriaCajeroModif} selectCombo={selectCombo} nombreAction={"habilitacionCajerosId"} selecciones={data} />
                                    </div>
                                </div>) : null}

                            { tarjetas.administradora.Id == 1 && (<div className="col-md-12">
                                <label className="label-primary">Cargo Cajeros Titular</label>
                                <div className="form-group bottom-separator-xs">
                                    <div className="funcionamiento-limites" > {productoVisa && productoVisa.UsoATM =="SC" ? "Uso de Cajeros sin Cargo para el Cliente" : "Uso de Cajeros con Cargo para el Cliente"} </div>
                                </div>
                             </div>) }

                        </div>
                    </div>) : null }
            </div>
        )
    }
}

export default TarjetaTitular;